import { BorderAreaCoveringEnum, CarriageWayEnum, Footer, LuminaireLayoutEnum, OptimizationTypeEnum, PClassEnum, RoadCoveringEnum } from "./types";

const strToBool = (str: string | undefined) => str?.toLowerCase() === "true";

export const appname = "RLX-FSC";
export const version = "0.0.1";
export const apiUrl = process.env.REACT_APP_API_URL;
export const rootUrl = `${process.env.REACT_APP_API_URL}/static_backend/images/fsc/`;
export const rootUrlAssets = `${process.env.REACT_APP_API_URL}/static_backend/assets/`;

export const API_URL = process.env.REACT_APP_API_URL;
export const STATS_URL = process.env.REACT_APP_STATS_URL;
export const STATS_ENABLE = process.env.REACT_APP_STATS_ENABLE;
export const APP_LOGO = process.env.REACT_APP_LOGO;
export const APP_LOGO_WHITE = process.env.REACT_APP_LOGO_WHITE;
export const APP_LOGO_SUBTITLE = process.env.REACT_APP_LOGO_SUB;
export const APP_LOGO_COMPANY = process.env.REACT_APP_COMPANY;
export const APP_COMPANY_INFO_LINK = process.env.REACT_APP_COMPANY_INFO_LINK ?? "https://www.relux.com/";
export const APP_COMPANY_NAME = (process.env.REACT_APP_COMPANY as "Signify" | "Relux" | "Trilux") ?? "Relux";
export const APP_COMPANY_COLOR = process.env.REACT_APP_COMPANY_COLOR ?? "#e6007e";
export const APP_COMPANY_FONT = process.env.REACT_APP_COMPANY_FONT ?? "Open Sans";

export const APP_CLASSES_SHOW_ASSISTANT = strToBool(process.env.REACT_APP_CLASSES_SHOW_ASSISTANT);

export const APP_CLASSES_SHOW_LEFT_RIGHT_TEXT = strToBool(process.env.REACT_APP_CLASSES_SHOW_LEFT_RIGHT_TEXT);
export const APP_CLASSES_SHOW_LEFT_RIGHT_PICTURE = strToBool(process.env.REACT_APP_CLASSES_SHOW_LEFT_RIGHT_PICTURE);
export const APP_RESULT_SHOW_3_RESULTS = strToBool(process.env.REACT_APP_RESULT_SHOW_3_RESULTS);
export const APP_SHOW_RESULT_PAGE_TEXT = strToBool(process.env.REACT_APP_SHOW_RESULT_PAGE_TEXT);

export const APP_ROAD_WIDTH: number | undefined = Number.parseFloat(process.env.REACT_APP_ROAD_WIDTH ?? "0");
export const APP_BORDER_AREA_WIDTH: number | undefined = Number.parseFloat(process.env.REACT_APP_BORDER_AREA_WIDTH ?? "0");
export const APP_KERB_DISTANCE: number | undefined = Number.parseFloat(process.env.REACT_APP_KERB_DISTANCE ?? "0");
export const APP_OPTIMIZATION_HEIGHT_LIGHT_POINT_STEP: number | undefined = Number.parseFloat(process.env.REACT_APP_OPTIMIZATION_HEIGHT_LIGHT_POINT ?? "0");
export const APP_OPTIMIZATION_TILT_OF_LAMINAR_STEP: number | undefined = Number.parseFloat(process.env.REACT_APP_OPTIMIZATION_TILT_OF_LAMINAR_STEP ?? "0");

export const APP_OPTIMIZATION_MAINTENANCE_FACTOR: number | undefined = Number.parseFloat(process.env.REACT_APP_OPTIMIZATION_MAINTENANCE_FACTOR ?? "0");

export const APP_PDF_FOOTER: Footer = (process.env.REACT_APP_PDF_FOOTER as Footer) ?? "signify";

export const FILTERS_ENABLED = strToBool(process.env.REACT_APP_FILTERS_ENABLED);

export const HEATMAPROOTWIDTH = 676;
export const SAMPLE_DESCRIPTION =
  "The CityCharm range is designed for use in urban areas where comfortable lighting, ambiance and design play an important role. It offers two iconic, timeless designs (Cordoba and Cone) and various accessories, enabling you to create a lighting solution that carries your signature, both by day and by night.CityCharm provides high visual comfort while maintaining excellent performance. It offers a choice of two innovative new Philips Lighting technologies: GentleBeam, which maximizes visual comfort, or ClearGuide, which optimizes vertical illumination and visual guidance.A variety of dedicated brackets and masts enables you to reshape your residential areas and city centers in the most elegant way imaginable.Further information about GentleBeam and ClearGuide technology can be found in the Product Guide.";

export const stepsIndex = ["Family", "Road Layout", "Roadway", "Lighting Class", "Optimization", "ResultTest", "Result Selection", "Result"];
export const STEPS = {
  FAMILY: {
    en: "Luminaire Selection",
  },
  ROAD_LAYOUT: {
    en: "Road Layout",
  },
  ROADWAY: {
    en: "Roadway",
  },
  LIGHTING_CLASS: {
    en: "Lighting Class",
  },
  LUMINAIRE_LAYOUT: {
    en: "Luminaire Layout",
  },
  OPTIMIZATION: {
    en: "Optimization",
  },
  RESULT_SELECTION: {
    en: "Result Selection",
  },
  RESULT: {
    en: "Result",
  },
};

export const STEP_IDS = [
  STEPS.FAMILY.en,
  STEPS.ROAD_LAYOUT.en,
  STEPS.ROADWAY.en,
  STEPS.LIGHTING_CLASS.en,
  STEPS.LUMINAIRE_LAYOUT.en,
  STEPS.OPTIMIZATION.en,
  STEPS.RESULT_SELECTION.en,
  STEPS.RESULT.en,
] as const;

export const TOOLTIPS = {
  ROADWAY: {
    covering:
      "<strong>The roadway's reflective characteristics.</strong><br/><br/><strong>R1</strong> : Diffuse<br/><br/> <strong>R2</strong> : Slightly specular <br/><br/> <strong>R3</strong>: Fairly specular <br/><br /> <strong>R4</strong> : Very specular <br/><br /> <strong>C1</strong> : Concrete <br/><br /> <strong>C2</strong> : Asphalt <br><br><mark>* Germany just uses C2 and R3</mark>",
    q0: "<strong>The roadway's photometric performance:</strong> <br/><br/> Where <strong>q</strong> represents the road's luminance coefficient, <strong>q0</strong> defines its diffuse behavior",
  },
};

export const illuminanceScale = [0, 0.5, 0.75, 1, 1.5, 2.0, 3.0, 5.0, 7.5, 10, 15, 20, 30, 50, 75, 100, 150];
export const luminanceScale = [0, 0.1, 0.15, 0.2, 0.3, 0.5, 0.75, 1, 1.5, 2, 3, 5, 7.5];

export const validStreedConfig = {
  roadWidth: { min: 0.01, max: 100 },
  numberOfLanes: { min: 1, max: 6 },
  widthOfCentralReservation: { min: 0, max: 100 },
  maintenanceFactor: { min: 0.1, max: 1 },
  borderAreaLeftWidth: { min: 0.01, max: 25 },
  borderAreaLeftKerbDistance: { min: 0, max: 25 },
  borderAreaRightWidth: { min: 0.01, max: 25 },
  borderAreaRightKerbDistance: { min: 0, max: 25 },
};

export const DEFAULT_PROJECT_CONFIG = {
  project_id: "",
  name_of_road: "",
  project_name: "",
  location: "",
  comment: "",
} as const;

export const StreeCalcDefaultConfig = {
  roadLayoutConfig: {
    carriageWay: CarriageWayEnum.SINGLE,
    borderAreaLeft: false,
    borderAreaRight: false,
  },
  projectConfig: { ...DEFAULT_PROJECT_CONFIG },
  roadwayConfig: {
    roadWidth: APP_ROAD_WIDTH || 7.0,
    widthOfCentralReservation: 2.0,
    numberOfLanes: 2,
    covering: RoadCoveringEnum.R3,
    q0: 0.08,
    borderAreaRightWidth: APP_BORDER_AREA_WIDTH || 2.0,
    borderAreaRightKerbDistance: APP_KERB_DISTANCE || 0.0,
    borderAreaRightCovering: BorderAreaCoveringEnum.DARK,
    borderAreaLeftWidth: APP_BORDER_AREA_WIDTH || 2.0,
    borderAreaLeftKerbDistance: APP_KERB_DISTANCE || 0.0,
    borderAreaLeftCovering: BorderAreaCoveringEnum.DARK,
    roadLength: 0,
  },
  lightingClassConfig: {
    roadClasses: PClassEnum.P4,
    borderAreaRightClasses: PClassEnum.P4,
    borderAreaLeftClasses: PClassEnum.P4,
    customClasses: {
      mainCustomClass: undefined,
      rightBorderCustomClass: undefined,
      leftBorderCustomClass: undefined,
    },
  },
  luminaireLayoutConfig: {
    luminaireConfig: LuminaireLayoutEnum.LEFT,
  },
  optimizationConfig: {
    optimizationType: APP_COMPANY_NAME.toLowerCase() === "trilux" ? OptimizationTypeEnum.LOWEST_CONSUMPTION : OptimizationTypeEnum.MAXIMUM_DISTANCE,
    ignoreTi: false,
    ignoreRei: false,
    shouldOptimizeDistanceBetweenPoles: true,
    distanceBetweenPoles: {
      value: 15,
      rangeValue: {
        min: 15.0,
        max: 60.0,
        step: 1.0,
      },
    },
    shouldOptimizeHeightOfTheLightPoint: false,
    heightOfTheLightPoint: {
      value: 8.0,
      rangeValue: {
        min: 3.0,
        max: 18.0,
        step: APP_OPTIMIZATION_HEIGHT_LIGHT_POINT_STEP || 0.5,
      },
    },
    shouldOptimizeOverhang: false,
    overhang: {
      value: 0.0,
      rangeValue: {
        min: -10,
        max: 10,
        step: 0.25,
      },
    },
    shouldOptimizeTiltOfTheLuminaire: false,
    tiltOfTheLuminaire: {
      value: 0.0,
      rangeValue: {
        min: 0.0,
        max: 15.0,
        step: APP_OPTIMIZATION_TILT_OF_LAMINAR_STEP || 2.5,
      },
    },
    maintenanceFactor: APP_OPTIMIZATION_MAINTENANCE_FACTOR || 0.8,
  },
};

console.log("StreeCalcDefaultConfig", StreeCalcDefaultConfig);

export const footers: { [key: string]: string } = {
  relux:
    "Please note that the results are based on RELUX calculations. This lighting concept is protected by copyright. The lighting concept is based on the documents and information provided to us and is to be checked by the respective property and specialist planners for further planning and implementation.",
  signify:
    "The indicated values are based on photometric laboratory measurements of the luminaires. In practice, gradual deviations may occur due to mechanical, geometrical, electrical, and photometric tolerances as well as due to the installation. This lighting calculation is a service supported by Signify GmbH, Hamburg and has a value of 250,- € © Signify GmbH - Hamburg",
  trilux:
    "Please note that the results are based on RELUX calculations. This lighting concept is a free service and is protected by copyright. The lighting concept is based on the documents and information provided to us, does not constitute a service analogous to HOAI and is to be checked by the respective property and specialist planners for further planning and implementation.",
};
